// import React, { lazy, Suspense, useState, useEffect } from "react";
// import { Routes, Route, useLocation } from "react-router-dom";
// import { Index } from "./index";
// import { Forgot } from "./SignIn/forgot";
// import { OtpScreen } from "./SignIn/otpScreen";
// import { ResetPassword } from "./SignIn/resetPassword";
// import { Topbar } from "../Components/TopBar";
// import { Sidebar } from "../Components/SideBar";
// import { Demo } from "./Demo";

// const SignIn = lazy(() => import("./SignIn/signin"));

// export const Layout = () => {
//   const location = useLocation();
//   const isAuthRoute = ["/", "/forgot", "/otp-screen", "/reset-password"].includes(location.pathname);

//   const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 992);

//   const toggleSidebar = () => {
//     setIsSidebarOpen((prev) => !prev);
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       setIsSidebarOpen(window.innerWidth >= 992);
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   return (
//     <div>
//       {isAuthRoute ? (
//         <main>
//           <Suspense
//             fallback={
//               <div className="loader-container">
//                 <div className="loader"></div>
//               </div>
//             }
//           >
//             <Routes>
//               <Route path="/" element={<SignIn />} />
//               <Route path="/forgot" element={<Forgot />} />
//               <Route path="/otp-screen" element={<OtpScreen />} />
//               <Route path="/reset-password" element={<ResetPassword />} />
//             </Routes>
//           </Suspense>
//         </main>
//       ) : (
//         <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
//           <Topbar toggleSidebar={toggleSidebar} />
//           <div style={{ display: "flex", flex: 1 }}>
//             <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
//             <div style={{ flex: 1, transition: "margin 0.3s" }}>
//               <main>
//                 <Suspense
//                   fallback={
//                     <div className="loader-container">
//                       <div className="loader"></div>
//                     </div>
//                   }
//                 >
//                   {/* <Routes>
//                     <Route path="/dashboard" element={<Index />} />
//                   </Routes> */}
//                   <Routes>
//                     <Route path="/dashboard" element={<Demo/>}/>
//                   </Routes>
//                 </Suspense>
//               </main>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

import React, { lazy, Suspense, useState, useEffect } from "react";
import {
  Routes,
  Route,
  useLocation,
  useNavigate,
  Navigate,
} from "react-router-dom";
import { Forgot } from "./SignIn/forgot";
import { OtpScreen } from "./SignIn/otpScreen";
import { ResetPassword } from "./SignIn/resetPassword";
import { SignIn } from "./SignIn/signin";
import { Topbar } from "../Components/TopBar";
import { Sidebar } from "../Components/SideBar";
import { Dashboard } from "./Dashboard/Dashboard";
import { ListAdmin } from "./ManageAdmin/listofAdmin";
import { ListWholesaler } from "./ManageWholesaler/listofWholesaler";
import { ListRetailer } from "./ManageRetailer/listofRetailer";
import { ListRider } from "./ManageRider/listofRider";
import { EditAdmin } from "./ManageAdmin/editAdmin";
import { AddAdmin } from "./ManageAdmin/addAdmin";
import { EditWholesaler } from "./ManageWholesaler/editWholesaler";
import { EditRetailer } from "./ManageRetailer/editRetailer";
import { WholeTransactionDetails } from "./WholeTransactionDetails/WholeTransactionDetails";
import { ViewWholeTransactionDetails } from "./WholeTransactionDetails/ViewWholeTransactionDetails";
import { TransactionWholesaler } from "./TransactionWholesaler/transactionWholesaler";
import { TransactionDetailsWholesaler } from "./TransactionWholesaler/TransactionDetailsWholesaler";
import { TransactionRetailer } from "./TransactionRetailer/transactionRetailer";
import { TransactionDetailsRetailer } from "./TransactionRetailer/TransactionDetailsRetailer";
import { TransactionRyder } from "./TransactionRyder/transactionRyder";
import { TransactionDetailesRyder } from "./TransactionRyder/TransactionDetailesRyder";
import { ListMedicine } from "./Medicine/listofMedicine";
import { AddMedicine } from "./ManageWholesaler/editMedicine/addMedicine";
import { EditMedicine } from "./Medicine/editMedicine";
import { NewDelivery } from "./Deliveries/newDeliveries";
import { ViewNewDeliveries } from "./Deliveries/ViewNewDeliveries";
import { ClosedDelivery } from "./Deliveries/closedDeliveries";
import { ClosedDeliveriesDetailes } from "./Deliveries/closedDeliveriesDetailes";
import { ReallotedDelivery } from "./Deliveries/reallotedDeliveries";
import { InprogressDelivery } from "./Deliveries/InProgress/inprogressDeliveries";
import { OutforDelivery } from "./Deliveries/InProgress/outforDelivery";
import { TrackDelivery } from "./Deliveries/InProgress/trackDelivery";
import { EachOrderDetails } from "./ManageWholesaler/editOrdersHistory/eachOrderDetails";
import { EditOrderHistory } from "./ManageWholesaler/editOrdersHistory/editOrder";
import { EachSubUser } from "./ManageWholesaler/editSubUsers/eachSubUser";
import { EditEachMedicine } from "./ManageWholesaler/editMedicine/editEachMedicine";
import { EachRetailerOrder } from "./ManageRetailer/editRetailerOrderHistory/eachRetailerOrder";
import { RetailerEachSubUser } from "./ManageRetailer/editRetailerSubUsers/retailerEachSubuser";
import { EditOrganizationRetailer } from "./ManageRider/editOrganizationRyder";
import { EditIndividualRetailer } from "./ManageRider/editIndividualRyder";
import { EditRyder } from "./ManageRider/editRyder";
import { EachRyderOrderDetails } from "./ManageRider/eachRyderOrderDetails";
import { RyderOrderHistory } from "./ManageRider/ryderOrderHistory";
import { WholesalerInvoice } from "./TransactionWholesaler/wholesalerInvoice";
import { RetailerInvoice } from "./TransactionRetailer/RetailerInvoice";
import { RyderInvoice } from "./TransactionRyder/RyderInvoice";
import { Preloader } from "../Components/Preloader";
import { AddMedicineMenu } from "./Medicine/addMedicine";
import { RyderZone } from "./RyderZone/ryderZone";
import { AddRyderZone } from "./RyderZone/addRyderZone";
import { EditRyderZone } from "./RyderZone/editRyderZone";
import { ContactUsData } from "./ContactUsData/contactUsData";
import { Pricing } from "./Pricing/pricing";
import { AddPricing } from "./Pricing/addPricing";
import { EditPricing } from "./Pricing/editPricing";
import { ComingSoon } from "./ComingSoon";
import { GlobalSetting } from "./GlobalSettings/GlobalSetting";
import { EditGlobalSetting } from "./GlobalSettings/EditGlobalSetting";
import { AgentsGlobalSettings } from "./AgentsGlobalSettings/AgentsGlobalSettings";
import { EditAgentsGlobalSettings } from "./AgentsGlobalSettings/EditAgentsGlobalSettings";
import { ReferralAgents } from "./ReferralAgents/ReferralAgents";
import { ViewReferralAgentsDetailes } from "./ReferralAgents/ViewReferralAgentsDetailes";
import { AgentWithdrawlRequests } from "./AgentWithdrawlRequests/AgentWithdrawlRequests";
import { TarackDeliveryHistoryDetailes } from "./Deliveries/tarackDeliveryHistoryDetailes";
import { WithdrawRequest } from "./WithdrawRequest/WithdrawRequest";
import { Invitations } from "./Invitations/Invitations";
import { DowloadDesktopApp } from "./DownloadDesktopApp/DowloadDesktopApp";
import {ViewDeliveryIdWiseUnassign } from "./Deliveries/View_DeliveryId_Wise_Unassign";
import { ViewDeliveryIdWiseReassign } from "./Deliveries/View_DeliveryId_Wise_Reassign";
import { GomakCash } from "./GomakCash/GomakCash";

export const Layout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isAuthRoute = [
    "/",
    "/forgot",
    "/otp-screen",
    "/reset-password",
    "/download-desktop-app"
  ].includes(location.pathname);

  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 992);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsSidebarOpen(window.innerWidth >= 992);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ❗ Redirect to dashboard if already logged in but on auth page
  useEffect(() => {
    if (token && isAuthRoute) {
      navigate("/dashboard", { replace: true });
    }
  }, [token, isAuthRoute, navigate]);

  if (loading) {
    return <Preloader />;
  }

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  if (!token && !isAuthRoute) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="allRoutes">
      {isAuthRoute ? (
        <main>
          <Routes>
            <Route path="/" element={<SignIn />} />
            <Route path="/forgot" element={<Forgot />} />
            <Route path="/otp-screen" element={<OtpScreen />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/download-desktop-app" element={<DowloadDesktopApp/>}/>
          </Routes>
        </main>
      ) : (
        <div style={{ display: "flex" }}>
          <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

          <div
            style={{
              flex: 1,
              marginLeft: window.innerWidth >= 992 ? "250px" : "0",
              transition: "margin 0.3s",
              width: "100%",
              overflow: "auto",
            }}
          >
            <Topbar toggleSidebar={toggleSidebar} />
            <main
              style={{ minHeight: "100vh", overflowX: "auto", padding: "20px" }}
            >
              <Routes>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/manage-admin" element={<ListAdmin />} />
                <Route path="/manage-admin-edit/:id" element={<EditAdmin />} />
                <Route path="/manage-admin-add" element={<AddAdmin />} />
                <Route path="/manage-wholesaler" element={<ListWholesaler />} />
                <Route
                  path="/manage-wholesaler-edit/:id"
                  element={<EditWholesaler />}
                />
                <Route
                  path="/manage-wholesaler-eachorder/:orderitem_id"
                  element={<EachOrderDetails />}
                />
                <Route
                  path="/manage-wholesaler-eachsubuser/:wholesalersubuser_id"
                  element={<EachSubUser />}
                />
                <Route
                  path="/manage-wholesaler-addmedicine"
                  element={<AddMedicine />}
                />
                <Route
                  path="/manage-wholesaler-editeachmedicine"
                  element={<EditEachMedicine />}
                />

                <Route path="/manage-retailer" element={<ListRetailer />} />
                <Route
                  path="/manage-retailer-edit/:id"
                  element={<EditRetailer />}
                />
                <Route
                  path="/manage-retailer-eachorder/:orderitem_id"
                  element={<EachRetailerOrder />}
                />
                <Route
                  path="/manage-retailer-eachSubuser/:retailersubuser_id"
                  element={<RetailerEachSubUser />}
                />

                <Route path="/manage-ryder" element={<ListRider />} />
                <Route
                  path="/manage-ryderedit-organization/:id"
                  // element={<EditOrganizationRetailer />}
                  element={<EditRyder />}
                />
                <Route
                  path="/manage-ryder-eachorder/:orderitem_id"
                  element={<EachRyderOrderDetails />}
                />
                <Route
                  path="/manage-ryderedit-individual"
                  element={<EditIndividualRetailer />}
                />

                {/* Transactions  */}
                <Route
                  path="/whole-transactions"
                  element={<WholeTransactionDetails />}
                />
                <Route
                  path="/view-whole-transactions/:order_id"
                  element={<ViewWholeTransactionDetails />}
                />

                <Route
                  path="/transaction-wholesaler"
                  element={<TransactionWholesaler />}
                />
                <Route
                  path="/transaction-wholesaler-details/:order_id"
                  element={<TransactionDetailsWholesaler />}
                />
                <Route
                  path="/transaction-retailer"
                  element={<TransactionRetailer />}
                />
                <Route
                  path="/transaction-retailers-details/:order_id"
                  element={<TransactionDetailsRetailer />}
                />
                <Route
                  path="/transaction-ryder"
                  element={<TransactionRyder />}
                />
                <Route
                  path="/transaction-ryder-details/:delivery_id"
                  element={<TransactionDetailesRyder />}
                />
                <Route
                  path="/transaction-wholesaler-invoice"
                  element={<WholesalerInvoice />}
                />
                <Route
                  path="/transaction-retailer-invoice"
                  element={<RetailerInvoice />}
                />
                <Route
                  path="/transaction-ryder-invoice"
                  element={<RyderInvoice />}
                />
                {/* Medicine  */}
                <Route path="/medicine" element={<ListMedicine />} />
                <Route path="/medicine-add" element={<AddMedicineMenu />} />
                <Route path="/medicine-edit/:id" element={<EditMedicine />} />
                {/* Deliveries  */}
                <Route path="/delivery" element={<NewDelivery />} />
                <Route
                  path="/view-new-delivery/:orderitem_id"
                  element={<ViewNewDeliveries />}
                />
                <Route path="/closed-delivery" element={<ClosedDelivery />} />
                <Route
                  path="/closed-delivery-details/:delivery_id"
                  element={<ClosedDeliveriesDetailes />}
                />
                <Route
                  path="/realloted-delivery"
                  element={<ReallotedDelivery />}
                />
                <Route
                  path="/inprogress-delivery"
                  element={<InprogressDelivery />}
                />
                <Route path="/out-for-delivery" element={<OutforDelivery />} />
                <Route
                  path="/track-delivery/:delivery_id"
                  element={<TrackDelivery />}
                />
                <Route
                  path="/track-delivery-detailes/:orderitem_id"
                  element={<TarackDeliveryHistoryDetailes />}
                />
                <Route path="/view-deliveryId_wise-unassign/:id" element={<ViewDeliveryIdWiseUnassign/>}/>
                <Route path="/view-deliveryId_wise-reassign/:id" element={<ViewDeliveryIdWiseReassign/>}/>
                {/* RyderZone  */}
                <Route path="/ryder-zone" element={<RyderZone />} />
                <Route path="/ryder-zone-add" element={<AddRyderZone />} />
                <Route
                  path="/ryder-zone-edit/:id"
                  element={<EditRyderZone />}
                />
                {/* withdraw request  */}
                <Route path="/withdraw-request" element={<WithdrawRequest/>}/>

                {/* Invitations  */}
                <Route path="/invitations" element={<Invitations/>}/>
                {/* Gomak Cash  */}
                <Route path="/gomak-cash" element={<GomakCash/>}/>

                {/* Global Setting */}
                <Route path="/global-setting" element={<GlobalSetting />} />
                <Route
                  path="/global-setting-edit/:id"
                  element={<EditGlobalSetting />}
                />

                {/* Referra lAgents */}
                <Route path="/referral-agents" element={<ReferralAgents />} />
                <Route
                  path="/referral-agents-detailes/:id"
                  element={<ViewReferralAgentsDetailes />}
                />

                {/* Agent Withdrawl Requests */}
                <Route
                  path="/agent-withdrawl-requests"
                  element={<AgentWithdrawlRequests />}
                />

                {/* Agents Global Setting */}
                <Route
                  path="/agents-global-setting"
                  element={<AgentsGlobalSettings />}
                />
                <Route
                  path="/agents-global-setting-edit/:id"
                  element={<EditAgentsGlobalSettings />}
                />

                {/* ContactUsData  */}
                <Route path="/contactus-data" element={<ContactUsData />} />
                {/* Pricing  */}
                {/* <Route path="/pricing" element={<Pricing />} />
                <Route path="/add-pricing" element={<AddPricing />} />
                <Route path="/edit-pricing/:id" element={<EditPricing />} /> */}
                <Route path="/coming-soon" element={<ComingSoon />} />

                {/* ❗ Catch-all route to redirect unknown paths */}
                <Route
                  path="*"
                  element={<Navigate to="/dashboard" replace />}
                />
              </Routes>
            </main>
          </div>
        </div>
      )}
    </div>
  );
};
